<template>
  <div
    id="offers-section"
    class="offer-component padding-top-s margin-bottom-m grid-container"
  >
    <div class="grid-x margin-bottom-m align-middle">
      <h3 class="cell shrink margin-right-xs">
        {{ OFFERS_CAROUSEL.CAROUSEL_TITLE }}
      </h3>
    </div>
    <div v-if="filteredOffers?.length">
      <Carousel
        :list="filteredOffers"
        :number-of-items="{ large: carouselWidth, medium: 2.3, small: 1.1 }"
        :gutter="{ large: 24, medium: 24, small: 24 }"
      >
        <template #item="slotProps">
          <OfferList
            :offer="slotProps.data"
            :index="slotProps.index"
            @exclusion-modal-handler="openInfoExclusionModal"
          />
        </template>
      </Carousel>
    </div>
    <div v-else-if="!filteredOffers.length && !unifiedLoyaltyError && !offersError">
      <div class="grid-x align-center-middle check-back-info">
        <div class="text-center">
          <p class="coming-soon eyebrow">
            {{ OFFERS_CAROUSEL.COMING_SOON }}
          </p>
          <p
            class="margin-top-xxs margin-bottom-xxs"
            :class="OFFERS_CAROUSEL.CLASS_NO_OFFER_HEADING"
          >
            {{ OFFERS_CAROUSEL.HEADING_ERR_NO_OFFERS }}
          </p>
          <p class="rewardInfo medium">
            {{ OFFERS_CAROUSEL.MSG_ERR_NO_OFFERS }}
          </p>
        </div>
      </div>
    </div>
    <div v-else-if="unifiedLoyaltyError || offersError">
      <div class="grid-x align-center-middle check-back-info">
        <div class="text-center">
          <p class="rewardInfo medium">
            {{ OFFERS_CAROUSEL.MSG_ERR_NO_STAR_REWARDS }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import Carousel from '@nuxt-common/atomic-ui/app/components/carousel/Carousel.vue';
import { OFFERS_CAROUSEL } from '../../config';
import OfferList from './OfferList';
import { useLoyaltyHubStore } from '../../stores/useLoyaltyHubStore.js';
import { useModalOverlayStore } from '../../stores/useModalOverlayStore';
import { loadOverlayComponent } from '../../utils/loadOverlayComponent';

const loyaltyHub = useLoyaltyHubStore();
const modalOverlayStore = useModalOverlayStore();

const unifiedLoyaltySummary = computed(() => loyaltyHub.unifiedLoyalty);
const unifiedLoyaltyError = computed(() => loyaltyHub.unifiedLoyaltyError);

const carouselWidth = ref(3.2);

const toggleModal = async (val) => {
  if (modalOverlayStore.showModal[val]) {
    modalOverlayStore.close(val);
  } else {
    modalOverlayStore.toggle(val);
  }
};
const setOverlay = async (val) => {
  modalOverlayStore.setModalOverlay(val);
};

const filteredOffers = computed(() => unifiedLoyaltySummary.value?.offerResponse?.offers || []);
const offersError = computed(() => unifiedLoyaltySummary.value?.offerResponse?.errors || false);

const carouselWidthHandler = () => {
  carouselWidth.value = 3.2;
  if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
    carouselWidth.value = 2.5;
  }
};
const openInfoExclusionModal = async (offer) => {
  const component = await loadOverlayComponent('exclusionsOverlay');
  await setOverlay({
    id: 'infoExclusionModal',
    title: OFFERS_CAROUSEL.HEADING_DETAILS_EXCLUSION,
    width: '50%',
    props: {
      offer,
    },
    component,
  });
  await toggleModal('infoExclusionModal');
};

onMounted(() => {
  carouselWidthHandler();
  window.addEventListener('resize', carouselWidthHandler);
});
onUnmounted(() => {
  window.removeEventListener('resize', carouselWidthHandler);
});
</script>




<style lang="scss" scoped>
@media screen and (max-width: 40em) {
  .isMew {
    width: 100%;
  }
}

.rewardInfo {
  color: $gray-1-color;
}

.check-back-info {
  height: rem-calc(286);
  background-color: $background-color;
}

@include breakpoint(small down) {
  .rewardInfo {
    width: rem-calc(287px);
    flex-shrink: 0;
  }
}


@import '~@core/csg/src/scss/settings/bcom.scss';
h3 {
  letter-spacing: $h3-letter-spacing;
}

.coming-soon {
  height: rem-calc(14px);
  align-self: stretch;
  color: $loyalty-1-color;
}
</style>